import React, { Component } from 'react';
import axios from 'axios';
import SmartImage from '../../subcomponents/SmartImage';
import Product from '../../../../reusable-components/Product/Product';
import gtmPusher from '../../../../utils/gtmPusher';
import Cta from '../../subcomponents/Cta';
import 'lazysizes';
import findAltText from '../../utils';

import './laydown.scss';

const Training = React.lazy(() => import('../../icons/Training'));
const Lifestyle = React.lazy(() => import('../../icons/Lifestyle'));

class Laydown extends Component {
  constructor(props) {
    super(props);

    this.state = {
      shownProduct: -1,
      display: 'none',
      products: [],
      apiLoaded: false,
      onlineProducts: [],
    };
  }

  componentDidMount() {
    let apiUrl = '/api/products/batch/?list=';
    if (this.props.isBootroom) apiUrl = 'https://www.unisport.dk/api/products/batch/?list=';
    const productIDArr = this.props.element.products.map(obj => obj.product);
    axios.get(`${apiUrl}${productIDArr.join()}`)
      .then((response) => {
        this.handleAnalytics(response.data.products);
        this.setState({
          products: response.data.products,
          apiLoaded: true,
          onlineProducts: this.filterProducts(this.props.element.products,
          response.data.products.map(prod => prod.id)),
        });
      });
  }

  handleAnalytics = (products) => {
    // GOOGLE ANALYTICS
    const ecommerceObj = {
      event: 'impressionView',
      eventCategory: 'ecommerce',
      eventAction: 'impression view',
      eventLabel: 'list',
      eventValue: 0,
      eventNonInteraction: true,
      currencyCode: products.length > 0 ? products[0].currency : 'N/A',
      list: `Laydown: ${this.props.element.laydownType}`,
    };
    const productArr = products.map((product, i) => {
      return {
        ...product,
        product_id: product.id,
        product: product.name,
        quantity: 1,
        unit_net: product.prices.min_price,
        size: null,
        variant: '',
        position: i,
      };
    });
    gtmPusher(ecommerceObj, productArr);
    // -- END GOOGLE ANALYTICS --
  }

  showProduct(event, pulserNr) {
    this.setState({
      shownProduct: pulserNr,
      display: 'block',
    });
  }

  // hide the current product when clicking anywhere that is not a pulser,
  // select or addToCart button
  hideProduct(event) {
    const isClickSelect = this.hasClass(event.target, 'select');
    const isClickPulser = this.hasClass(event.target, 'pulser');
    const isClickOption = this.hasClass(event.target, 'option');
    const isClickProduct = this.hasClass(event.target, 'sliderProduct');
    const isClickAddToCart = this.hasClass(event.target, 'productAddToCart');
    if (!isClickSelect
      && !isClickPulser
      && !isClickAddToCart
      && !isClickProduct
      && !isClickOption) {
      if (this.state.shownProduct !== -1) {
        this.setState({ shownProduct: -1 });
      }
    }
  }

  hasClass(element, className) {
    return (` ${element.className} `).indexOf(` ${className} `) > -1;
  }

  // Removes products that are not currently online, which will disable the pulser for it.
  filterProducts(products, onlineProductIDs) {
    const onlineProducts = [];
    products.forEach((product) => {
      if (onlineProductIDs.includes(product.product)) {
        onlineProducts.push(product);
      }
    });
    return onlineProducts;
  }

  render() {
    const { campaignType, order } = this.props;
    const {
    laydownType,
    isNike,
    cta,
    position,
    textColor,
    svgColor,
    noBackground,
    backgroundColor,
    useGradient,
    backgroundGradient,
    gradientDirection,
    hide,
    laydownNumber,
    type, anchorName,
    roundedCorners,
    hideCTA,
    textAnimation,
    titleColor,
    useMobileText,
    mobileTextColor,
    mobileTitleColor,
    hideTitleAndText,
    removeArrow,
    } = this.props.element;
    const { slug, imagePattern } = this.props.url;
    const translations = window.campaign_data.campaign_translations.blocks;
    const commonTranslations = window.campaign_data.common_translations.blocks;
    const oppositePosition = position === 'left' ? 'right' : 'left';
    let laydownPath = `${laydownType === 'training' ? `140-laydown-${laydownType}` : `160-laydown-${laydownType}`}${imagePattern.split('.')[0]}.png`;
    if (campaignType === 'general') laydownPath = `140-laydown${laydownNumber}${imagePattern.split('.')[0]}.png`;
    let imageName = '140-laydown-training-background';
    if (laydownType === 'lifestyle') {
      imageName = '160-laydown-lifestyle-background';
    }
    if (campaignType === 'general') imageName = `140-laydown-background${laydownNumber}`;
    let pattern;
    if (isNike && window.innerWidth < 768) {
      pattern = `-nike${imagePattern}`;
    } else {
      pattern = imagePattern;
    }
    let displayTextColor = textColor;
    let displayTitleColor = titleColor;
    if (useMobileText && window.innerWidth < 768) displayTextColor = mobileTextColor;
    if (useMobileText && window.innerWidth < 768) displayTitleColor = mobileTitleColor;
    const roundTheCorners = (campaignType === 'general' && roundedCorners) ? 'rounded-corners' : '';
    const uppercaseLetters = this.props.url.generalData
      ? this.props.url.generalData.uppercaseLetters : false;

    const pulsers = this.state.onlineProducts.map((product, index) => {
      const style = {
        left: `${product.left}%`,
        top: `${product.top}%`,
      };
      return (
        // We know that this.state.onlineProducts and this.state.products
        // will have same length and ordering - see filterProducts()
        this.state.apiLoaded &&
          <div
            key={product.product}
            className={`pulser pulser-${index}`}
            style={style}
            onClick={event => this.showProduct(event, index)}
            role="button"
            tabIndex="0"
          >
            {this.state.shownProduct === index &&
            <div className={`product-holder ${position}`} style={{ display: this.state.display }}>
              <Product
                product={this.state.products[index]}
                commonTranslations={window.campaign_data.common_translations.blocks}
                isLaydown
                isBootroom={this.props.isBootroom}
                // addToCartForm
                isCampaign
              />
            </div>
            }
          </div>);
    });

    const pictureStyle = {
      width: '100%',
      maxWidth: 'auto',
      display: 'block',
      lineHeight: '0',
    };

    const sectionClasses = ['component', 'laydown-section'];
    if (isNike) sectionClasses.push('isNike');
    if (noBackground) sectionClasses.push('smart-section');

    let styler = {};
     if (noBackground && useGradient && gradientDirection === 'leftToRight') {
       styler = { background: `linear-gradient(to right, ${backgroundColor} 0%, ${backgroundGradient} 100%)` };
    } else if (noBackground && useGradient && gradientDirection === 'topToBottom') {
       styler = { background: `linear-gradient(${backgroundColor} 0%, ${backgroundGradient} 100%)` };
    } else if (noBackground && !useGradient) {
       styler = { background: backgroundColor };
    } else {
       styler = {};
    }
    let component = null;
    if (!hide) {
      component = (
        <section
          id={anchorName || ''}
          className={sectionClasses.join(' ')}
          style={styler}
          onClick={event => this.hideProduct(event)}
          role="presentation"
          dataorder={order}
          datatype={type}
        >
          {!noBackground &&
            <SmartImage
              slug={slug}
              name={`${imageName}${pattern}`}
              version={this.props.version}
              campaignType={campaignType}
              className={campaignType === 'general' ? 'heightBackground' : ''}
              alt={findAltText(`Laydown Background ${laydownNumber}`, translations[`laydown${laydownNumber}title`])}
            />
          }
          {this.props.campaignType === 'general' &&
            <div className="mainWidth">
              <div className={`${position} laydown-picture`}>
                {pulsers}
                <picture>
                  <source media="(min-width: 1680px)" srcSet={`${slug}2160/${laydownPath}?version=${this.props.version}`} />
                  <source media="(min-width: 768px)" srcSet={`${slug}1680/${laydownPath}?version=${this.props.version}`} />
                  <source srcSet={`${slug}mobile/${laydownPath}?version=${this.props.version}`} />
                  <img src={`${slug}mobile/${laydownPath}?version=${this.props.version}`} alt={findAltText(`Laydown Image ${laydownNumber}`, translations[`laydown${laydownNumber}title`])} className="laydown" style={pictureStyle} />
                </picture>
              </div>
              {(position !== 'center' && !hideTitleAndText) &&
                <div data-animation-type={textAnimation} className="laydown-textholder holderWidth">
                  <h2
                    className={uppercaseLetters ? 'title title--uppercase' : 'title'}
                    style={{ color: displayTitleColor }}
                  >
                    {translations[`laydown${laydownNumber}title`]}
                  </h2>
                  <p className="text" style={{ color: displayTextColor }}>
                    {translations[`laydown${laydownNumber}text`]}
                  </p>
                  {!hideCTA && (
                    <Cta
                      className={roundTheCorners}
                      url={translations[`laydown${laydownNumber}link`]}
                      translation={commonTranslations.shopnow}
                      backgroundColor={cta.ctaBackgroundColor}
                      textColor={cta.ctaTextColor}
                      ctaArrowColor={cta.ctaArrowColor}
                      borderColor={cta.ctaBorderColor}
                      noArrow={removeArrow}
                      campaignType={campaignType}
                    />
                  )}
                </div>
              }
            </div>
          }
          {this.props.campaignType !== 'general' &&
            <div className="mainWidth">
              {isNike &&
                <div className={`${position} nike-picture laydown-picture`}>
                  {pulsers}
                  <picture>
                    <source media="(min-width: 1680px)" srcSet={`${slug}2160/${laydownPath}`} />
                    <source media="(min-width: 768px)" srcSet={`${slug}1680/${laydownPath}`} />
                    <source srcSet={`${slug}mobile/${laydownPath}`} />
                    <img src={`${slug}mobile/${laydownPath}?version=${this.props.version}`} alt={findAltText(`Laydown Image ${laydownNumber}`, translations[`laydown${laydownNumber}title`])} className="laydown" style={pictureStyle} />
                  </picture>
                </div>
              }

              {laydownType === 'training' ?
                !isNike &&
                <div className={`${oppositePosition} laydown-svg`}>
                  <React.Suspense fallback={null}>
                    <Training
                      lang={window.campaign_data.common_translations.language}
                      color={svgColor}
                    />
                  </React.Suspense>
                </div>
              :
                <div className={`${oppositePosition} laydown-svg`}>
                  <React.Suspense fallback={null}>
                    <Lifestyle
                      lang={window.campaign_data.common_translations.language}
                      color={svgColor}
                    />
                  </React.Suspense>
                </div>
              }

              {!isNike &&
                <div className={`${position} laydown-picture`}>
                  {pulsers}
                  <picture>
                    <source media="(min-width: 1680px)" srcSet={`${slug}2160/${laydownPath}?version=${this.props.version}`} />
                    <source media="(min-width: 768px)" srcSet={`${slug}1680/${laydownPath}?version=${this.props.version}`} />
                    <source srcSet={`${slug}mobile/${laydownPath}?version=${this.props.version}`} />
                    <img src={`${slug}mobile/${laydownPath}?version=${this.props.version}`} alt={findAltText(`Laydown Image ${laydownNumber}`, translations[`laydown${laydownNumber}title`])} className="laydown" style={pictureStyle} />
                  </picture>
                </div>
              }

              {isNike === true &&
                <div className="nike-text">
                  <div className={`nike-svg ${oppositePosition} laydown-svg`}>
                    <React.Suspense fallback={null}>
                      <Training
                        lang={window.campaign_data.common_translations.language}
                        color={svgColor}
                      />
                    </React.Suspense>
                  </div>
                  <p className="text" style={{ color: textColor }}>{translations.nikefootballtrainingtext}</p>
                  <React.Suspense fallback={null}>
                    <Cta
                      className={roundTheCorners}
                      url="/v/nike-football-training"
                      translation={commonTranslations.explore}
                      backgroundColor={cta.ctaBackgroundColor}
                      textColor={cta.ctaTextColor}
                      ctaArrowColor={cta.ctaArrowColor}
                      borderColor={cta.ctaBorderColor}
                    />
                  </React.Suspense>
                </div>
              }
            </div>
          }
        </section>
      );
    }

    return (
      <React.Fragment>
        { component }
      </React.Fragment>
    );
  }
}

export default Laydown;
